var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        attrs: {
          "server-items-length": _vm.rackEggIndexGetCount,
          items: _vm.rackEggIndexList,
          headers: _vm.headers,
          page: _vm.page,
          "items-per-page": _vm.itemsPerPage,
          dense: "",
          loading: _vm.rackEggIndexGetting
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", lg: "6", md: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "mb-0 pb-0",
                          attrs: {
                            label: "search",
                            dense: "",
                            "append-icon": "mdi-magnify"
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", lg: "6", md: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "mt-0 pt-0",
                          attrs: { label: "Date", dense: "", type: "date" },
                          model: {
                            value: _vm.date,
                            callback: function($$v) {
                              _vm.date = $$v
                            },
                            expression: "date"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item.incubator_rack_id",
            fn: function({ item }) {
              return [
                _c("span", { staticClass: "font-weight-bold primary--text" }, [
                  _vm._v(_vm._s(item.rack_code.code))
                ]),
                _vm.accessLevel > 6
                  ? _c(
                      "v-icon",
                      {
                        attrs: { color: "yellow darken-3" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("edit", item)
                          }
                        }
                      },
                      [_vm._v("mdi-pencil")]
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.date",
            fn: function({ value }) {
              return [_c("span", [_vm._v(_vm._s(value.dateFormat()))])]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }